// extracted by mini-css-extract-plugin
module.exports = {"fixedWrapper":"GlobalProgressBar_fixedWrapper__1v3Sy"};